import React from 'react';
import { FileIcon, AlertCircle } from 'lucide-react';

export const EmptyState = ({ 
  icon: Icon = FileIcon, 
  title, 
  description, 
  action 
}) => {
  return (
    <div className="text-center py-12 px-4" data-testid="empty-state">
      <Icon className="w-16 h-16 mx-auto text-slate-300 mb-4" strokeWidth={1} />
      <h3 className="text-lg font-medium text-slate-900 mb-2">{title}</h3>
      {description && (
        <p className="text-slate-500 mb-6 max-w-sm mx-auto">{description}</p>
      )}
      {action && <div>{action}</div>}
    </div>
  );
};

export const ErrorState = ({ message, onRetry }) => {
  return (
    <div className="text-center py-12 px-4" data-testid="error-state">
      <AlertCircle className="w-16 h-16 mx-auto text-red-300 mb-4" strokeWidth={1} />
      <h3 className="text-lg font-medium text-slate-900 mb-2">Error</h3>
      <p className="text-slate-500 mb-6">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-[#1B4D3E] font-medium hover:underline"
        >
          Reintentar
        </button>
      )}
    </div>
  );
};

export const LoadingState = ({ message = 'Cargando...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12" data-testid="loading-state">
      <div className="w-10 h-10 border-2 border-slate-200 border-t-[#1B4D3E] rounded-full animate-spin mb-4" />
      <p className="text-slate-500">{message}</p>
    </div>
  );
};

export default EmptyState;
